import { render } from "./VotingResultMessage.vue?vue&type=template&id=010087dd&scoped=true"
import script from "./VotingResultMessage.vue?vue&type=script&lang=js"
export * from "./VotingResultMessage.vue?vue&type=script&lang=js"

import "./VotingResultMessage.vue?vue&type=style&index=0&id=010087dd&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010087dd"]])

export default __exports__